import { CollegeTypeSelector } from './CollegeTypeSelector';
import { useSelectorSubmit } from './useSelectorSubmit';

export const CollegeTypeSelectorPanel = () => {
  const { required, submit } = useSelectorSubmit('collegeTypeSelector');

  return (
    <CollegeTypeSelector
      onSubmit={(types) => submit(types.join(', '))}
      onSkip={!required ? () => submit('None') : undefined}
    />
  );
};
